import { DefaultErrorResponse, IRestfulApiService } from '@/lib/apiService'
import { isEmpty } from '@/lib/helpers'
import {
	GetProductsQueryDTO,
	GetProductsResponseDTO,
	IQueryCommand,
} from '@bookips/solvook-api-shared'
import { ProductStoreType } from '../stores/ProductModel'
// import { toProductFromServer } from '../../mappers/toProductFromServer'

/**
 *
 * * GET /api/v1/products
 *
 * @summary [상품] 상품 리스트 가져오기
 * @description 상품 리스트를 가져온다 query의 offset 과 limit으로 페이지네이션을 하고 product_type에 따라서 상품 리스트를 가져온다
 * @pathParam {string} - product_type - 상품 타입
 * @response 200 - {product[]}
 * @tag 전체 상품 조회
 */

type GetProductsCommandError = DefaultErrorResponse & {}

export class GetProductsCommand
	implements IQueryCommand<GetProductsQueryDTO, any, GetProductsResponseDTO>
{
	private apiService: IRestfulApiService
	private productStore: ProductStoreType

	constructor(apiService: IRestfulApiService, productStore?: ProductStoreType) {
		this.apiService = apiService
		this.productStore = productStore
	}

	async execute(dto: GetProductsQueryDTO): Promise<GetProductsResponseDTO> {
		const url = `/products`
		const params = new URLSearchParams()

		Object.keys(dto).forEach((key) => {
			if (dto[key] !== undefined) {
				if (dto[key] instanceof Array) {
					dto[key].forEach((value) => {
						if (!isEmpty(value)) {
							params.append(key, value)
						}
					})
				} else {
					if (!isEmpty(dto[key])) {
						params.append(key, dto[key])
					}
				}
			}
		})

		// if (category) {
		// 	params.set('category', category)
		// }
		//
		// if (offset != undefined) {
		// 	params.set('offset', offset.toString())
		// }
		//
		// if (limit != undefined) {
		// 	params.set('limit', limit.toString())
		// }
		// if (filter != undefined) {
		// 	params.set('filter', filter)
		// }
		//
		// if (q != undefined) {
		// 	params.set('q', q)
		// }

		try {
			const response = await this.apiService.fetch<GetProductsResponseDTO>(url, { params })

			if (this.productStore) {
				const {
					products: { products, pagination },
				} = response.data
				// const converted = products.map((raw) => toProductFromServer(raw))

				// console.log('converted', converted)

				this.productStore.products.update({
					products: products,
					pagination: pagination,
				})
			}

			return response.data
		} catch (e) {
			return null
			// if (isAxiosError(e)) {
			// 	const axiosError = e as AxiosError<GetProductListCommandError>
			// 	console.error('axiosError', axiosError.message)
			//
			// 	return {
			// 		errors: [axiosError.response.data.message],
			// 		resultCode: 500,
			// 		success: false,
			// 	}
			// }
		}
	}
}
